module.exports = __webpack_public_path__ + "img/weather.7b12ed75.webp";